export default {
  data() {
    return {
      gtmSubsection: 'Legal',
      gtmSubsection2: '',
      defaultDataLayer: {
        event: 'pageview',
        section: 'Corporate Website',
        subsection: '',
        subsection2: '',
        language: this.$i18n.locale,
        logged: false,
      },
    }
  },

  methods: {
    gtmInit(subsection, subsection2) {
      this.$gtm.init('GTM-TT4GHQX')
      this.defaultDataLayer.subsection = subsection
      this.defaultDataLayer.subsection2 = subsection2
      this.$gtm.push({ ...this.defaultDataLayer })
    },
  },

  created() {
    this.gtmInit(this.gtmSubsection, this.gtmSubsection2)
  },
}
